<template>
  <v-container class="pa-0">
    <v-row>
      <v-col>
        <home-card
          v-for="(homeCard, homeCardIndex) in homeBarCards"
          :key="homeCardIndex"
          :selected-item="homeCard"
        />
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col class="pt-0">
        <home-card
          :selected-item="homeForm"
        />
      </v-col>
    </v-row>

    <home-modals />
  </v-container>
</template>

<script>
import HomeMixin from 'src/home/store/utils/home-mixin'

export default {
  name: 'HomeBar',
  components: {
    HomeCard: () => import('src/home/components/HomeCard'),
    HomeModals: () => import('src/home/components/HomeModals'),
  },
  mixins: [
    HomeMixin,
  ],
  computed: {
    homeBarCards() {
      return this.homes
    },
    homeForm() {
      return this.emptyHomeCard
    },
  },
}
</script>
